import { get, isNil } from "lodash";
import { PUBLISH_STATES } from "./editor-header";

export const MENU_KEYS = {
  REPLACE_PDF: "REPLACE_PDF",
  RENAME: "RENAME",
  DOWNLOAD_ORIGINAL: "DOWNLOAD_ORIGINAL",
  DOWNLOAD_PREVIEW: "DOWNLOAD_PREVIEW",
  HISTORY: "HISTORY",
  DISCARD: "DISCARD",
  EXPORT: "EXPORT",
  IMPORT: "IMPORT",
};

export const editorMenuItems = ({
  t,
  pendingFile,
  zoneSource,
  preview,
  hasDraft,
}) => [
  { key: MENU_KEYS.REPLACE_PDF, label: t("MENU.REPLACE_PDF") },
  { key: MENU_KEYS.RENAME, label: t("MENU.RENAME") },
  {
    key: MENU_KEYS.DOWNLOAD_ORIGINAL,
    label: t(
      isNil(pendingFile) ? "MENU.DOWNLOAD_ORIGINAL" : "MENU.DOWNLOAD_NEW_PDF",
    ),
    disabled: !isNil(pendingFile) && get(zoneSource, "source.pending") !== true,
  },
  {
    key: MENU_KEYS.DOWNLOAD_PREVIEW,
    label: t("MENU.DOWNLOAD_PREVIEW"),
    disabled: isNil(preview.bytes) || !isNil(pendingFile),
  },
  { key: MENU_KEYS.HISTORY, label: t("MENU.HISTORY") },
  ...(hasDraft
    ? [{ key: MENU_KEYS.DISCARD, label: t("MENU.DISCARD"), danger: true }]
    : []),
  { type: "divider" },
  { key: MENU_KEYS.EXPORT, label: t("MENU.EXPORT") },
  { key: MENU_KEYS.IMPORT, label: t("MENU.IMPORT") },
];

export const publishStateOf = ({ ready, total, unpublished }) => {
  if (ready < total) return PUBLISH_STATES.NOT_READY;
  return unpublished ? PUBLISH_STATES.READY : PUBLISH_STATES.PUBLISHED;
};
